import React, { useState, useEffect } from "react";
import Snackbar from "@mui/joy/Snackbar";
import Typography from "@mui/joy/Typography";
import { errorBus } from "../errorHandle";

const GlobalSnackbar = ({ error: SError }: any) => {
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (SError) {
      setError(SError.message);
      setOpen(!!SError);
    }
  }, [SError]);
  useEffect(() => {
    // 订阅错误总线
    const unsubscribe = errorBus.subscribe((message: any) => {
      setError(message);
      setOpen(true);
    });

    return () => unsubscribe();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      variant="soft"
      color="danger"
      onClose={handleClose}
      sx={{
        // maxWidth: 400,
        boxShadow: "lg",
        borderRadius: "md",
        zIndex: 9999,
      }}
    >
      <div>
        {/* <Typography level="title-md">请求错误</Typography> */}
        <Typography level="body-sm" sx={{ mt: 0.5 }}>
          {error}
        </Typography>
      </div>
    </Snackbar>
  );
};

export default GlobalSnackbar;
